import YesNoInput from './YesNoInput';
export default YesNoInput;